module.exports = __webpack_public_path__ + "img/ico-notice-active.18e68919.png";